
angular.module('mtic.components.login').directive('loginReturnModal', function (EventManager, LoginCookie, api) {
      const eventManager = new EventManager('loginReturnModal');
      
      eventManager.listen('login:session:restore', function () {
            window.focus();
            const accounts = LoginCookie.getSessionLoginTokens();
            if (accounts.length > 0) {
                  const lastAccount = accounts.pop();
                  if (lastAccount) {
                        logBackIn(lastAccount);
                  }
            }
            
      });

      const logBackIn = function(account){
            eventManager.broadcast('logging-in');
            LoginCookie.clearSessions();
            api.loginRestore(account.username, account.userid, account.sessionkey, account.firebaseToken)
                  .then(() => {
                        eventManager.broadcast('done-login-attempt');
                  })
                  .catch(function(){
                        eventManager.broadcast('done-login-attempt');
                  });
            if (account.role === 'mtic_student' && account.lastItem && account.lastItem) {
                  eventManager.listen('creating-items-done', () => {
                        eventManager.broadcast('module:select:resource', {slug:account.lastItem, dontSelect: true, centerOnItem: true, highlightItem: true});
                  });
            }
      };

      return {
            templateUrl: 'template.html',
            restrict: 'E',
            scope: {},
            link: function (scope) {
                  scope.isOpen = false;
                  scope.accounts = [];
                  scope.close = function () {
                        scope.isOpen = false;
                  }
                  scope.currentDisplay = function () {
                        return scope.isOpen ? 'block' : 'none';
                  }
            }
      }
})
